<template>
  <div>
    <div id="data-list-list-view" class="data-list-container mt-5">
      <div class="flex mb-4 px-2">
        <div class="flex-1 px-2">
          <vs-input class="w-100 inputx" placeholder="E-mail" v-model="filters.email"/>
        </div>
        <div class="flex-1 px-2">
          <Datepicker
            :language="ptBR"
            :clear-button="true"
            placeholder="Data de Cadastro Inicial"
            :use-utc="true"
            format="dd/MM/yyyy"
            v-model="filters.created_at.start"
          />
        </div>
        <div class="flex-1 px-2">
          <Datepicker
            :language="ptBR"
            :clear-button="true"
            placeholder="Data de Cadastro Final"
            :use-utc="true"
            format="dd/MM/yyyy"
            v-model="filters.created_at.end"/>
        </div>
      </div>

      <div class="flex justify-center">
        <div>
          <vs-pagination :max="10" :total="affiliates.last_page" v-model="affiliates.current_page"></vs-pagination>
        </div>
      </div>

      <vs-table
        ref="table"
        noDataText="Nenhum item encontrado no período selecionado"
        @selected="handleClick"
        :data="data"
        :sst="true"
        :stripe="true"
      >
        <template slot="thead">
          <vs-th>ID</vs-th>
          <vs-th>NOME</vs-th>
          <vs-th>EMAIL</vs-th>
          <vs-th>CHAVE PIX</vs-th>
          <vs-th>DATA DE CADASTRO</vs-th>
          <vs-th>SITUAÇÃO</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" v-for="(tr, idx) in data" :key="idx">
            <vs-td :data="data[idx].id">{{ data[idx].id }}</vs-td>
            <vs-td :data="data[idx].name">
              {{
                data[idx].name
              }}
            </vs-td>
            <vs-td :data="data[idx].email">
              {{
                data[idx].email
              }}
            </vs-td>
            <vs-td :data="data[idx].pix_key">{{ data[idx].pix_key }}</vs-td>
            <vs-td :data="data[idx].created_at">{{ data[idx].created_at | formatDateTime }}</vs-td>
            <vs-td :data="data[idx].active">
              <span v-if="data[idx].active === 1">Ativo</span>
              <span v-else>Inativo</span>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <div class="flex justify-center">
        <div>
          <vs-pagination :max="10" :total="affiliates.last_page" v-model="affiliates.current_page"></vs-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import {ptBR} from 'vuejs-datepicker/dist/locale'

export default {
  components: {
    Datepicker
  },
  data() {
    return {
      ptBR,
      affiliates: {
        current_page: 1,
        last_page: 1
      },
      filters: {
        created_at: {
          start: null,
          end: null
        },
        email: null,
      },
      data: [],
      timeout: null
    }
  },

  mounted() {
    let filters = JSON.parse(localStorage.getItem(`filters-${this.$route.fullPath}`))

    console.log(this.$route.query.email)

    if (this.$route.query.email && !this.filters.email) {
      if (!filters) {
        filters = {
          created_at: {
            start: null,
            end: null
          },
          email: null
        }
      }

      filters.email = this.$route.query.email
    }

    if (filters) {
      this.filters = filters
    } else {
      this.load()
    }
  },

  methods: {
    load() {
      this.$vs.loading()

      localStorage.setItem(`filters-${this.$route.fullPath}`, JSON.stringify(this.filters))

      if (this.filters.email) {
        this.filters.email = this.filters.email.trim()
      }

      this.$api
      .get('/api/v1/backend/affiliates', {
        params: {
          page: this.affiliates.current_page,
          filters: this.filters
        }
      })
      .then((response) => {
        this.$vs.loading.close()
        this.data = response.data.data
        this.affiliates = response.data
      })
    },
    handleClick(row) {
      this.$router.push({name: 'cliente-detalhes', params: {id: row.id}})
    }
  },

  watch: {
    filters: {
      handler() {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.load()
        }, 600)
      },
      deep: true
    },
    'affiliates.current_page'() {
      this.load()
    }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          bg-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
